
import React from "react";
import { UseFormReturn } from "react-hook-form";
import { StrategyProvider } from "@/types/strategy-types";
import { NameField } from "./basic/NameField";
import { ProviderField } from "./basic/ProviderField";
import { ExchangeField } from "./basic/ExchangeField";
import { InvestmentField } from "./basic/InvestmentField";
import { RiskLevelField } from "./basic/RiskLevelField";
import { CurrencyField } from "./basic/CurrencyField";
import { PlanField } from "./basic/PlanField";
import { DescriptionField } from "./basic/DescriptionField";

interface BasicFieldsProps {
  form: UseFormReturn<any>;
  providers: StrategyProvider[];
  isProvider?: boolean;
}

const BasicFields = ({ form, providers, isProvider }: BasicFieldsProps) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <NameField form={form} />
      <ProviderField form={form} providers={providers} isProvider={isProvider} />
      <ExchangeField form={form} />
      <InvestmentField form={form} />
      <RiskLevelField form={form} />
      <CurrencyField form={form} />
      <PlanField form={form} />
      <DescriptionField form={form} />
    </div>
  );
};

export default BasicFields;
